import getSelectedTableView from '../../utils/getSelectedTableView';
import unselectAll from './unselectAll';
import { mutatorAction } from 'satcheljs';
import { wrapFunctionForDatapoint } from 'owa-analytics';

export default wrapFunctionForDatapoint(
    { name: 'CancelMultiSelect' },
    function multiSelectCancel() {
        // Unselect all first
        unselectAll();
        updateTableViewOnCancelMultiSelect();
    }
);

const updateTableViewOnCancelMultiSelect = mutatorAction(
    'updateTableViewOnCancelMultiSelect',
    () => {
        const tableView = getSelectedTableView();
        tableView.isInCheckedMode = false;
    }
);
